<template >
<div style="margin-bottom: 59px">
  <div style="display: flex;background: #f69d02;position: fixed;width: 100%;z-index: 999;">
    <div style="height: 59px;margin: 0 5%;display: flex; align-items: center;">
      <img alt="Vue logo" src="../assets/image/logo1.png" class="logo_img">
    </div>
    <div style="flex: 1">
      <el-menu
          mode="horizontal"
          background-color="none"
          text-color="white"
          active-text-color="#ffd04b"
          class="el-menu-demo disMenu"
      >
        <el-menu-item @click="handleSelect(item)" v-for="item in menuList" :index="item.value" :key="item.value">{{item.name}}</el-menu-item>
      </el-menu>
      <div class=" disMenua">
        <div class="menu_mobile">

          <el-dropdown>
            <el-icon :size="26" color="white"><Fold /></el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="handleSelect(item)" v-for="item in menuList" :index="item.value" :key="item.value">{{item.name}}</el-dropdown-item>

              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="right_box" style="height: 59px;margin: 0 5%;">
    </div>
  </div>
</div>

</template>
<script>
export default {
  name: 'HelloWorld',
  // props: {
  //   msg: String
  // }
  data(){
    return{
      activeIndex2:1,
      menuList:[{
        name:'首页',value:1,path:'/'
      },{
        name:'关于汇米巴',value:1,path:'/about'
      },{
        name:'品牌动态',value:1,path:'/dynamic'
      },{
        name:'美味鲜食',value:1,path:'/cat'
      },{
        name:'便利生活',value:1,path:'/life'
      },{
        name:'我要加盟',value:1,path:'/join'
      },{
        name:'城聘英才',value:1,path:'/want'
      },],
      displayMenu:false,
    screenWidth: 0


    }
  },
methods: {
  handleSelect(e) {
    this.activeIndex2 = e.value
    this.$router.push(e.path)
  },
},

  mounted() {

  }
}
</script>

<style scoped>
.logo_img{
  height: 70%;width: auto;padding:10px
}
:deep .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: transparent;
  color: #FF5000 !important;
  outline: none;
}
:deep .el-dropdown-menu__item:not(.is-disabled):focus, .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: white;
  color:  #FF5000;
}
.el-menu--horizontal.el-menu {
  border-bottom:none;
}
.el-menu--horizontal>.el-menu-item.is-active {
   border-bottom: 0 solid var(--el-menu-active-color);
   color: white !important;
}
.aa{
  display: block;
}
@media (min-width:1000px) {

  .disMenua {
    display: none;
  }
}
@media (max-width:1000px) {
  .disMenu {
    display: none !important;
  }
  .logo_img{
    height: 50%;width: auto;padding:10px
  }
.right_box{
  display: none;
}
}
.disMenua{
  height: 59px;
}
.menu_mobile{
display: flex;
  align-items: center;
  justify-content: end;
  height: 100%;
  padding: 0 20px;
}
.el-menu--horizontal {
  border-right: none;
  display: flex
;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  height: var(--el-menu-horizontal-height);
}
</style>